// extracted by mini-css-extract-plugin
module.exports = {"button":"SidebarButtonElement_button__1L7n2"};